<template>
  <div class="col-12 col-md-2 col-lg-2" style="cursor: pointer;" @click="detailEstate">
    <div class="card shadow-sm">
      <div class="card-body">
        <div class="d-flex justify-content-end">
          <div class="dropdown">
            <div :style="{'border': '1px solid '+ $getCssVariable('--bs-primary') }" class="btn btn-icon btn-icon-muted btn-active-light w-30px h-30px" type="button" data-bs-toggle="dropdown" @click.stop>
              <i class="fas fa-ellipsis-v text-primary fs-3"></i>
            </div>
            <ul class="dropdown-menu">
              <li>
                <span class="dropdown-item d-flex py-3 align-items-center" style="cursor: pointer;" @click.stop="updateEstate">
                  <i class="fas fa-edit me-3"></i>
                  <span>{{$t('button.edit')}}</span>
                </span>
              </li>
              <li>
                <span class="dropdown-item d-flex py-3 align-items-center" style="cursor: pointer;" @click.stop="deleteEstate">
                  <i class="fas fa-trash me-3"></i>
                  <span>{{$t('button.delete')}}</span>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div class="d-flex justify-content-center mb-5">
          <img src="/assets/media/estate.png" style="width: 70px; height: auto; margin-top: -15px !important;">
        </div>
        <div class="d-flex justify-content-center">
          <span class="fs-2">{{ estate.name }}</span>
        </div>
      </div>
    </div>  
  </div>

  <DetailEstate :id="'estate_detail_modal_'+estate?.id" :detail="estate" @load="loadEstates"/>
  <UpdateEstate :id="'estate_update_modal_'+estate?.id" :form="formDataEstate" :edit="true" @load="loadEstates"/>
</template>

<script setup>
  import { useSwal } from "@/composables/useSwal";
  import i18n from "@/plugins/i18n";
  import { defineProps, ref, watch } from "vue";
  import DetailEstate from "../views/Projects/components/modals/DetailEstate.vue";
  import UpdateEstate from "../views/Projects/components/modals/CreateOrUpdateEstate.vue";
  import { useStore } from "vuex";
  
  const emits = defineEmits(['load'])

  const props = defineProps({
    estate: {
      type: Object,
      default: {}
    },
  })
  const { showSwal } = useSwal();
  const store = useStore()

  const formDataEstate = ref({...props.estate, project_id: ''})

  watch(
    () => props.estate,
    (newVal) => {
      formDataEstate.value = { ...newVal, project_id: '' }
    },
    { deep: true }
  )

  function updateEstate() {
    formDataEstate.value = { ...formDataEstate.value, project_id: '' }
    $('#estate_update_modal_'+props.estate?.id).modal('toggle')
  }

  function detailEstate() {
    $('#estate_detail_modal_'+props.estate?.id).modal('toggle')
  }

  function loadEstates() {
    emits('load')
  }

  function deleteEstate() {
    showSwal(
        i18n.global.t('projects.estates.swal.delete'),
        i18n.global.t('projects.estates.swal.delete_message')
    ).then( async (result) => {
      if (result.value) {
        store.dispatch('projects/deleteProjectEstate', props.estate?.id)
          .then((response) => {
            loadEstates()
            window.toastr['success'](i18n.global.t('notification.estate_deleted'))
          })
      }
    });
  }
</script>

<style scoped>
  .dropdown-item:active {
      color: #fff !important;
      text-decoration: none;
      background-color: var(--bs-primary)
  }
  .dropdown-item {
      color: var(--bs-primary)
  }

  .dropdown-item:active i {
      color: #fff !important;
  }
  .dropdown-item i {
      color: var(--bs-primary)
  }
</style>